import FundDetailsModal from './FundDetailsModal'

export default FundDetailsModal
